<template>
  <div>
    <el-dialog
      custom-class="real-dialog"
      title="编辑订单金额"
      :visible="dialogVisible"
      width="500px"
      @close="handleClose"
      append-to-body
      center>
      <el-form :model="form" :rules="rules" ref="ruleForm" label-width="120px">
        <el-form-item label="修改为" prop="payableAmount">
          <el-input v-model.number="form.payableAmount" placeholder="请输入订单金额"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleClick">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import showdialog from '@/minxs/showdialog'

export default {
  data() {
    return {
      form: {
        payableAmount: '',
      },
      rules: {
        payableAmount: [
          { required: true, message: '订单金额不能为空', trigger: 'blur' },
          { type: 'number', message: '订单金额必须为数字值'}
        ],
      },
    };
  },
  mixins:[showdialog],
  methods: {
    handleClick() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          // console.log(this.form.payableAmount);
          this.$emit("changeEnterAmount", {value: this.form.payableAmount, key: 'payableAmount'});
          this.handleClose()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  }
};
</script>
